import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';

import { ProductDataSourceDTO } from 'src/app/core/http/product-search/model/product-search';
import { OutletExtendedDataDTO } from 'src/app/core/http/outlet/model/outlet';

export interface GeneralDataSharing {
  productSearchFiltersArea?: {
    searchOptionsForm: any
  },
  productSearchTable?: {
    dataSource: MatTableDataSource<ProductDataSourceDTO> | undefined,
    filtersFormGroup: any,
    selection: SelectionModel<ProductDataSourceDTO> | undefined,
    sort: MatSort | undefined,
  }
  selectedOutlet?: OutletExtendedDataDTO;
}

export const noData: GeneralDataSharing = {
  productSearchFiltersArea: {
    searchOptionsForm: undefined
  },
  productSearchTable: {
    dataSource: undefined,
    filtersFormGroup: undefined,
    selection: undefined,
    sort: undefined
  },
  selectedOutlet: undefined,
};
